import en from '@fkhplus/common/src/assets/languages/en.json';
import hi from '@fkhplus/common/src/assets/languages/hi.json';

export const resources = {
    en,
    hi
  };